import React, { Component } from 'react';
import { observer } from "mobx-react";
import TextFieldTracking from '../TextFieldTracking';

import './ObjectCard.css'

interface MyProps {
  title: string,
  definition: string,
  score: number,
  remove: Function,
  active: boolean,
}

class ObjectCard extends Component<MyProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      modalIsOpen: false,
      loadingSubjects: false,
      subtitle: "subtitle",
      submitSpinner: false,
    };
  }

  openObject() {

  }

  render() {
    var submitSpinner;

    if (this.state.submitSpinner) {
      submitSpinner = <img className="pull-right" src="/images/ajax-loader.gif" />
    } else {
      submitSpinner = <span></span>
    }

    return (
      <div>
        <div className="gallery-card-title">
          <span className="new-link" onClick={this.openObject}>{this.props.title}</span>
        </div>
        <div className="gallery-card-definition">
          {this.props.definition}
        </div>
      </div>
    );
  }
}

export default ObjectCard;

/* <TextFieldTracking position="pull-right" number={this.props.score} /> */
